import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { JobTitleMappingService } from 'src/shared/services/job-title-mapping.service';
import { JobTitleMapping } from 'src/shared/models/job-title-mapping.model';
import { JobTitle } from 'src/shared/models/job-title.model';
import { JobTitleService } from 'src/shared/services/job-title.service';
import { MappingComponentBase } from 'src/shared/admin-page/mapping-page-base.component';

@Component({
  selector: 'smt-job-title-mapping',
  templateUrl: './job-title-mapping.component.html',
  styleUrls: ['./job-title-mapping.component.scss']
})
export class JobTitleMappingComponent extends MappingComponentBase implements OnInit {
    
    allJobTitles: JobTitle[];
    sortOptions: string[] = [ "Client Job Title", "Mapped Value", "Last Modified Date", "Last Modified By" ];

    constructor(
        public _jobTitleMappingService: JobTitleMappingService,
        protected _changeDetector: ChangeDetectorRef,
        private _jobTitleService: JobTitleService) {
        super(_jobTitleMappingService, _changeDetector);
    }

    async ngOnInit() {
        let jobTitleResult = await this._jobTitleService.getJobTitles();
        this.allJobTitles = jobTitleResult;
    }

    public getSortOptions(): string[] {
        return this.sortOptions;
    }

    getDisplayName(mapping: JobTitleMapping): string {
        return mapping.clientJobTitle;
    }

    getJobTitleName(jobTitleId: number|null): string {
        let jobTitleName = '';
        if (this.allJobTitles && jobTitleId != null) {
            let jobTitle = this.allJobTitles.find(c => c.id == jobTitleId);
            jobTitleName = jobTitle.position;
        }
        return jobTitleName;
    }
}
